// extracted by mini-css-extract-plugin
module.exports = {"block":"SubscribeBlock_block__JlPPl"};